<!--
    描述：平台账户入口页面
    时间：2021-01-06
    Created by ws
-->
<template>
    <transition name="fade" mode="out-in">
        <!-- 用做缓存页面 -->
        <keep-alive :include="cachedViews">
            <router-view :key="key" />
        </keep-alive>
    </transition>
</template>

<script>
import { mapState } from 'vuex'
export default {
    name: 'Account-home',
    data() {
        return {}
    },
    methods: {},
    computed: {
        ...mapState('tags', {
            cachedViews: state => state.cacheTags
        }),
        key() {
            // console.log(this.$route.name)
            return this.$route.name
        }
    }
}
</script>

<style scoped lang="less">
</style>